import Vue from "vue";
import axios from "axios";
// import { MessageBox, Message } from 'element-ui'
import router from "@/router";
const handleCode = (code, msg) => {
  switch (code) {
    case 400:
      Vue.prototype.$baseMessage(msg, "error");
      break;
    case 401:
      Vue.prototype.$baseMessage("登录失效", "error");
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        location.reload();
      }, 2000);
      break;
    default:
      Vue.prototype.$baseMessage(msg, "error");
      break;
  }
};
var service = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api1"
      : "https://dtkapi.fjjxhl.com",
  // withCredentials: true,
  timeout: 50000,
  headers: {
    "Content-type": "application/json;charset=UTF-8",
  },
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做什么
    console.log(config, "configconfig", config.url === "/getcard_detaildown");
    if (!config.data) config.data = {};
    if (config.url === "/getcard_detaildown") {
      config.headers["Authorization"] = null;
    } else {
      let token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
    }
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    if (config.method === "options") {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    handleCode(error.response.status, error.response.statusText);
    return Promise.reject(error);
  }
);

// 添加相应拦截器
service.interceptors.response.use(
  (response) => {
    // 对相应数据做点什么
    const { data, config } = response;
    const { status, message } = data;
    console.log(message, 12, response);
    if (status == 200) {
      return data;
    } else {
      handleCode(status, message);
      return Promise.reject(
        `请求异常拦截:${JSON.stringify({
          status,
          message,
        })}` || "Error"
      );
    }
  },
  (error) => {
    const { response, message } = error;
    if (error.response && error.response.data) {
      const { status, data } = response;
      handleCode(status, response.message || message);
      return Promise.reject(error);
    } else {
      let { message } = error;
      if (message === "Network Error") {
        message = "后端接口连接异常";
      }
      if (message.includes("timeout")) {
        message = "后端接口请求超时";
      }
      if (message.includes("Request failed with status code")) {
        const code = message.substr(message.length - 3);
        message = `后端接口异常`;
      }
      Vue.prototype.$baseMessage(message || `后端接口未知异常`, "error");
      return Promise.reject(error);
    }
  }
);

export default service;
